import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Badge} from '@/components/ui/badge/Badge'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSearchParams} from '../../types'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {formatNumber, formatPercentage} from '@/utilities/helpers'
import {StyledAccessesGrid} from './style'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'

const calculateCompletionPercentage = (completed: number, planned: number): {percentage: number} => {
    if (!planned || planned === 0) {
        return {percentage: 0}
    }

    const completionRate = (completed / planned) * 100
    return {
        percentage: completionRate
    }
}

export const DashboardAccessesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({fields: ['graph'], ...searchParams})

    const completed = data?.accessCounters?.completed ?? 0
    const planned = data?.accessCounters?.planned ?? 0
    const {percentage} = calculateCompletionPercentage(completed, planned)

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:accesses')} />
    }

    return (
        <DashboardCard title={t('dashboard:accesses')}>
            <StyledAccessesGrid>
                <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                    {formatNumber(completed)}
                </Text>
                <Flexbox align="center" gap={1}>
                    <Badge variant={percentage > 50 ? 'success' : 'danger'} size="sm">
                        {formatPercentage(percentage / 100)}
                    </Badge>
                    <Text palette="neutral" shade="600" size="textSm" weight={400}>
                        {t('dashboard:accesses_vs_planned')}
                    </Text>
                </Flexbox>
            </StyledAccessesGrid>
        </DashboardCard>
    )
}
